import { clientLoadMore } from '../util/loadMore';

export default {
  init() {
    const serverLoadMoreInterventionsParlementaires = ({button, displayedItems, representantId = null}) => {
      $.ajax({
        // eslint-disable-next-line no-undef
        url: ajax_object.ajax_url,
        method: 'POST',
        data: { action: 'get_interventions_parlementaires', start_index: displayedItems, representant: representantId },
        // eslint-disable-next-line no-undef
        success: (res) => {
          if (res) {
            const resultsList = $('#js-results-interventions');
            resultsList.append(res);
          } else {
            button.classList.add('!hidden');
          }
        },
        // eslint-disable-next-line no-undef
        error: (res) => console.warn('error', res),
      });
    };
    
    const handleLoadMoreInterventionsParlementaires = () => {
      const loadMore = $('#js-load-more-interventions');
      loadMore.on('click', (e) => {
        const displayedItems = $('#js-results-interventions .js-result-item:not(.hidden)').length;
        const initiallyLoadedItemsCount = $('#js-results-interventions').attr('data-initially-loaded-items');
        if (displayedItems < 20) {
          clientLoadMore({ button: e.target, withAjax: true, increment: 5, listId: 'js-results-interventions', initiallyLoadedItemsCount });
        } else {
          const representantId = $('#js-results-interventions').attr('data-representant');
          serverLoadMoreInterventionsParlementaires({button: e.target, displayedItems, representantId});
        }
      });
    };
    handleLoadMoreInterventionsParlementaires();
  },
};